import React, { useState } from "react";
import StatusCircle from "../Status/StatusCircle";
import styles from './Chip.module.scss'
import TabContent from "./TabContent";
import TabNavItem from "./TabNavItem";
 
const Chip = (props: ChipProps) => {
  const [activeTab, setActiveTab] = useState("id-0");
  const {tabNavHeaderItems, tabContentItems} = props;
  
  return (
    <div className={`Tabs`}>

      {tabNavHeaderItems.length > 1 &&
        <>
          <ul className={`nav ${styles.nav} mt-3`}>
            {tabNavHeaderItems.map((header: string, index: number) =>{
              return (
                <TabNavItem 
                  key={`nav-${index}`}
                  id={`id-${index}`}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  title={header} 
                  hasStatusCircle={props.hasStatusCircle}
                /> 
              )
            })}
          </ul>
          <hr />
        </>
      }
      
      <div className="outlet">
        {tabContentItems.map((contentElement: React.ReactNode, index: number) =>{
          return (
            <TabContent 
              key={`content-${index}`}
              id={`id-${index}`}
              activeTab={activeTab}
            >
              {contentElement}
            </TabContent>
          )
        })}

      </div>
    </div>
  );
};
 
export default Chip;

interface ChipProps {
  tabNavHeaderItems: string[];
  tabContentItems: React.ReactNode[];
  hasStatusCircle: boolean;
}

